import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import "./registerServiceWorker";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
// import { library } from "@fortawesome/fontawesome-svg-core";
import Notifications from "vue-notification";
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Notifications);
// library.add(faTimesCircle);
// Vue.component("font-awesome-icon", FontAwesomeIcon);

const lastClear = localStorage.getItem('lastClear');
const now  = (new Date()).getTime();

if ((now - lastClear) > 1000 * 60 * 60 * 1) {
  localStorage.clear();
  localStorage.setItem('lastClear', now);
}

if (localStorage.getItem('dignificarlamemoria.org') != null) {
  store.commit('setUser', JSON.parse(localStorage.getItem('dignificarlamemoria.org')).user)
}

// router.beforeEach((to, from, next) => {
//   if (to.path != "/login") {
//     if (store.state.user.isAuthenticated) {
//       next();
//     } else {
//       next("login");
//     }
//   } else {
//     next();
//   }
// });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
